"use strict";
/*
 * Created on 06 06 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>
 * Encapsulates {@link Product product} and {@link InternalSite site} with meaning that product is new at certain site. It encapsulates
 * actual state, there is no time validity for now (it can be added if needed).
 * </p>
 *
 * <p>
 * If a product is stated as new at some site, it does not have to mean that product is new for targeted system. Each system can use
 * different rules to declare product as new.
 * </p>
 *
 * <p>
 * You can also come out of this entity to create a report, etc.
 * </p>
 *
 * @author VRu
 * @author JMe
 */


var ProductSiteNew =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductSiteNew, _DomainObject_1$Domai);

  /**
   * @param id internal id of entity
   * @param productId reference to internal product
   * @param siteId reference to internal site
   * @param processed defines whether an instance was processed
   */
  function ProductSiteNew(id, productId, siteId, processed) {
    var _this;

    _classCallCheck(this, ProductSiteNew);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSiteNew).call(this));
    _this.id = id;
    _this.productId = productId;
    _this.siteId = siteId;
    _this.processed = processed;
    return _this;
  }

  return ProductSiteNew;
}(DomainObject_1.DomainObject);

exports.ProductSiteNew = ProductSiteNew;
/**
 * data schema
 */

ProductSiteNew.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductSiteNew.name);
  return {
    id: builder.id('id'),
    productId: builder.str('productId'),
    siteId: builder.str('siteId'),
    processed: builder.bool('processed')
  };
}();